import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csnamespace(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# namespace tutorial For Beginners</title>
 <meta name="description" content="C# namespace tutorial for beginners.namespace in C# is The namespace is a logical container of types and the main purpose is to group the items. CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# namespace,c# namespace for,c sharp namespace,c# namespace for loop,namespace tutorial for begineers in C#" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-namespace" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Namespace in C#</h1>
    <div className="first">
        <a href="/csharp-literal">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-string">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<h2 className="mt-4 mh2">what is namespace in C#</h2>
<p className="mt-4 para">The namespace is a logical container of types and the main purpose is to group the items. The main use of namespace is to separate the classes means you create 6 classes inside a project  and if you want to be a  group of 2 classes in a single group so you create 3 groups means 3 namespace<br/>
If You want  to change the namespace name so you change no problem create inside the program after the namespace name change.<br/>
<span className="bold mt-4">Important namespace in C#: </span> If a class name is first  and this class inside the namespace
</p>



      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-2">namespace </span>
            <span className="qwerty-7">namespace</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">class  </span>
            <span className="qwerty-5">Program </span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-7">static </span>
            <span className="qwerty-4">void Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-5">String </span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-3"> args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-6">Console</span>
            <span className="qwerty-3">.WriteLine</span>
            <span className="qwerty-1">(" </span>
            <span className="qwerty-3">hello </span>
            <span className="qwerty-5">world </span>
            <span className="qwerty-1">")</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">hello </span>
            <span className="qwerty-5">world </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
      
  <h1 className="mt-5">  </h1>

  <div className="back">
        <a href="/csharp-literal">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-string">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csnamespace;